// Everything in this file is being actively deprecated
import { picker } from '../src/date_picker'
import { debounce } from "lodash"
import '../src/date'
import { bindCalPickerComponent } from "../src/rails/month_year_calendar"
import Button from '../src/button'
import { formatDate } from '../src/utils'
import { sub } from "date-fns"

document.addEventListener("DOMContentLoaded", () => {
  bindCraftyDatePickers()
  // used on the rails month year cal picker
  bindCalPickerComponent()
})

export const bindCraftyDatePickers = () => {
  [ ...document.getElementsByClassName('crafty-range-start')].forEach(el => {
    const elementEnd = el.closest('.crafty-date-range-container').querySelector('.crafty-range-end')
    picker(el, {dateRange: true, elementEnd })
  });
  [ ...document.getElementsByClassName('crafty-icon-range-picker')].forEach(el => {
    const inDrawer = [ ...el.classList].includes('in-drawer-icon')
    picker(el, {dateRange: true, inDrawer, icon: true })
  })
}

window.bindCraftyDatePickers = bindCraftyDatePickers

window.debounceIt = debounce
window.bindCalPickerComponent = bindCalPickerComponent
window.Button = Button
window.formatDate = formatDate
window.dateFnsSub = sub


